export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '日本女优大全收录了哪些类型的女优？',
    answer: '日本女优大全收录了影视剧女优、偶像女优、新生代女优、实力派女优、晨间剧女优等多种类型的日本演艺女演员。我们持续更新数据库，确保信息的全面性和时效性。每位女优的页面都包含详细介绍、出道信息、代表作品、获奖记录等完整资料。',
  },
  {
    question: '网站上的女优信息多久更新一次？',
    answer: '我们的编辑团队每天关注日本演艺圈的最新动态，确保在24小时内更新女优的最新作品、新闻和排名变化。新出道女优的信息通常在一周内完成收录和整理。',
  },
  {
    question: '如何快速找到特定女优的资料？',
    answer: '您可以通过首页的搜索栏直接输入女优姓名（支持中文和日文）进行搜索，也可以在分类页面按类型浏览，或使用标签筛选功能。每位女优都有专属页面，包含完整的个人资料和作品列表。',
  },
  {
    question: '女优的代表作品是如何评选的？',
    answer: '代表作品的评选综合考虑了作品的收视率、票房、口碑评价、获奖情况以及在女优职业生涯中的重要性。我们参考了日本国内权威的影视评价机构和媒体的评选标准，力求客观公正。',
  },
  {
    question: '网站上的图片是否有版权问题？',
    answer: '本网站使用的图片均为公开宣传物料或经过合理使用的编辑性图片。如果您是版权所有者且不希望您的图片出现在本站，请联系我们，我们会在收到通知后及时处理。',
  },
  {
    question: '可以投稿推荐新的女优信息吗？',
    answer: '当然可以！我们非常欢迎影迷朋友们通过关于我们页面的联系方式投稿推荐新的女优信息或指出信息错误。对于被采纳的投稿，我们会在女优页面注明贡献者以示感谢。',
  },
];